function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 34 34"
}, props), React.createElement("path", {
  d: "M27.8 19.51L17.46 29.83A.8.8 0 0117 30a.61.61 0 01-.45-.17L6.18 19.5a15.13 15.13 0 01-3.44-4.88 7.99 7.99 0 01-.63-4.58c.27-1.4.93-2.62 2-3.68 1.57-1.56 3.47-2.34 5.71-2.34s4.15.78 5.72 2.34A8.47 8.47 0 0117 8.3a8.47 8.47 0 011.45-1.93A7.76 7.76 0 0124.17 4c2.24 0 4.16.8 5.75 2.37a6.8 6.8 0 011.98 3.68c.25 1.4.04 2.93-.64 4.58a15.16 15.16 0 01-3.45 4.88z"
})));